// Announcements shown at the top of the agent dashboard.
// audience: 'residence' | 'rise' | 'both'. Newest first.
// Kelly will move these to Firebase with the admin posting form next.
export const ANNOUNCEMENTS = [
  {
    id: 'intro-resi-2026-10-11',
    audience: 'residence',
    date: '2026-10-11',
    title: 'Introducing Resi',
    body: 'Your performance platform, built for our agents. Follow every deal from contract to close, know what is due next and where you stand, and find onboarding, the CMA builder, and marketing materials in one spot.',
    image: '/announcements/resi-announcement.png',
    cta: 'Questions? Call or text Kelly at 239-488-5900',
  },
];
